// Helper Methods
/**
 * Gets the form title based on context, trimmed:
 *    Forms in dialog get the ui-dialog title
 *    Forms on page get the widget title
 *
 * If not found, returns empty string.
 *
 * @param {jQuery} form the form as a jquery object
 * @returns {string} the form title, or empty string
 */
const getFormTitle = (form) => {
	const formTitle =
		// mycars forms
		form?.getAttribute('data-mycars-form-tracking-id') ||
		// get dialog title
		form?.closest('.ui-dialog')?.querySelector('.ui-dialog-title')
			?.textContent ||
		// get form title
		form?.closest('[data-widget-id]')?.querySelector('h1, .widget-heading')
			?.textContent ||
		// title of navigation forms
		form?.closest('.nav-fragment')?.previousElementSibling?.textContent ||
		// get widget title
		form?.closest('[data-widget-id]')?.firstElementChild?.textContent ||
		// you get nothing!
		'';

	return formTitle.trim();
};

export default getFormTitle;
